import React, { useEffect, useState, useContext } from "react";
import { useForm } from 'react-hook-form';
import { DynamicSelect } from "../../components/DynamicSelect";
import Flex from '@react-css/flex';
import Modal from 'react-modal';
import api from '../../services/api';
import Swal from "sweetalert2";
import { StyledForm } from "../../styled-components/StyledForm.style";
import TimeSheetDetalhesContext from "../../contexts/TimeSheetDetalhesContext";


const getCancelamentos = async (codeType) => {
    let cancelamentos = null;
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': false
        },
        params: { codeType }
    }
    try {
        const response = await api.get(`Settings/genericlist/list`, config);
        cancelamentos = response.data.data;
    } catch (err) { }
    return cancelamentos;
}

export const ModalCancel = ({ isOpen, onAfterOpen, onRequestClose }) => {
    const { register } = useForm();
    var [cancelamentos, setCancelamentos] = useState([]);
    var [cancelamento, setCancelamento] = useState(null);
    var [idCancelamento, setIdCancelamento] = useState(null);
    var [descricao, setDescricao] = useState(null);
    const { timesheetItemAtividade, setTimesheetItemAtividade, idTimesheetItemAtividade, setIdTimesheetItemAtividade } = useContext(TimeSheetDetalhesContext);

    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '35%',
            overflowY: 'auto',
            minHeight: '45%',
            maxHeight: '90%'
        },
        overlay: {
            zIndex: 9999
        }
    };

    const getCancelamento = (currentValue, value) => {
        var cancelamentoResult = cancelamentos.filter(function (o) {
            return o.key == value;
        });
        cancelamento = cancelamentoResult[0].value;
        idCancelamento = cancelamentoResult[0].key;
        setCancelamento(cancelamento);
        setIdCancelamento(idCancelamento);
    };

    const handleDescricao = (valor) => {
        descricao = valor;
        setDescricao(descricao);
    };

    const cancelarAtividadePost = async () => {
        let result = null;
        let msg = descricao?.target?.value;
        if(!descricao?.target?.value && idCancelamento == 4) {
                registrationFailure("Descrição do cancelamento é um campo obrigatório para Tipo de Cancelamento Outro!");
            }
            else {
                if(descricao?.target?.value){
                    msg = descricao?.target?.value;
                }
                else {
                    msg = cancelamento;
                }
            }

        let params = {
            idTimesheetItemAtividade: idTimesheetItemAtividade,
            idTipoAtividadeCancelado: idCancelamento,
            mensagem: msg
        }

        if (idCancelamento == null) {
            Swal.fire({
                title: "Atenção",
                text: "Selecione um tipo de cancelamento",
                icon: "warning",
                showConfirmButton: false,
                timer: 2000,
            });
            return;

        }


        try {
            const response = await api.post(`Timesheet/atividade/cancelar`, params);
            onRequestClose();
            registrationSuccess();
            result = response.data;
            return result;


        } catch (err) {
            //registrationFailure();
            return result;
        }
    };

    const registrationSuccess = () => {
        Swal.fire({
            title: "Sucesso",
            text: "Cancelamento realizado com sucesso",
            icon: "success",
            timer: 2000,
            showConfirmButton: false,
        }).finally(() => {
            window.location.reload(false);
        });
    }

    const registrationFailure = (mensagem = "Ops, ocorreu um erro ao realizar o cancelamento. Tente novamente em instantes.") => {
        Swal.fire({
            title: "Atenção",
            text: mensagem,
            icon: "error",
            confirmButtonText: "OK",
        });
    }

    useEffect(() => {
        const asyncFn = async () => {
            const cancelamentos = await getCancelamentos(42);
            if (!!cancelamentos) {
                setCancelamentos(cancelamentos)
            }
        }
        asyncFn()
    }, []);

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={onRequestClose}
            contentLabel="Timesheet Atividades"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledForm>
                <p className="modal-close" onClick={onRequestClose}>X</p>
            </StyledForm>
            <Flex style={{ display: 'flex !important' }}>
                <StyledForm>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <p className="modal-title">Cancelar Lançamento de Atividade</p>
                        </Flex.Item>
                    </Flex>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div className="position-relative form-group">
                                <div>
                                    <p className="modal-info">Status</p>
                                    <p className="modal-info-data">{timesheetItemAtividade.statusAtividade.statusNome}</p>
                                    <p className="modal-info">Atividade</p>
                                    <p className="modal-info-data">{timesheetItemAtividade.atividade.atividadeNome}</p>
                                    <p className="modal-info">Data Lançamento</p>
                                    <p className="modal-info-data">{timesheetItemAtividade.lancamento.dataLancamento}</p>
                                    <p className="modal-info">Hora Final</p>
                                    <p className="modal-info-data">{timesheetItemAtividade.lancamento.horaFinal}</p>
                                    <p className="modal-info">Total de Horas</p>
                                    <p className="modal-info-data">{timesheetItemAtividade.lancamento.totalHoras}</p>
                                </div>
                            </div>
                        </Flex.Item>
                        <Flex.Item className="modal-width">
                            <div className="position-relative form-group">
                                <div>
                                    <p className="modal-info">Perito</p>
                                    <p className="modal-info-data">{timesheetItemAtividade.perito.peritoNome}</p>
                                    <p className="modal-info">Descrição Atividade</p>
                                    <p className="modal-info-data">{timesheetItemAtividade.atividade.descricao}</p>
                                    <p className="modal-info">Hora Inicial</p>
                                    <p className="modal-info-data">{timesheetItemAtividade.lancamento.horaInicial}</p>
                                    <p className="modal-info">Descontar Refeição</p>
                                    <p className="modal-info-data">{timesheetItemAtividade.lancamento.descontarRefeicao ? 'Sim' : 'Não'}</p>
                                </div>
                            </div>
                        </Flex.Item>
                    </Flex>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div style={{ width: '100%' }} className="position-relative form-group">
                                <DynamicSelect required="required" register={register} placeholder={''} valuetext={cancelamento} label={'Tipo Cancelamento'} name={'idCancelamento'} options={cancelamentos} keyValue={'key'} keyLabel={'value'} paramMethod={getCancelamento} />
                            </div>
                        </Flex.Item>
                    </Flex>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div style={{ width: '100%' }} className="position-relative form-group">
                                <textarea rows="3" maxLength="500" className="input-form" placeholder='Descrição' name='descricao' onBlur={handleDescricao} />
                            </div>
                        </Flex.Item>
                    </Flex>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div className="position-relative form-group modal-align-center">
                                <input className='default-button-red' value='Cancelar lançamento' type="button" onClick={cancelarAtividadePost} />
                            </div>
                        </Flex.Item>
                    </Flex>
                </StyledForm>
            </Flex>
        </Modal>
    );
};
